module.exports = __webpack_public_path__ + "img/BlueWhiteHalf.e9d50894.jpg";